import React, { FC } from 'react';

import {
  Stack,
  HStack,
  AccordionButton,
  Box,
  AccordionPanel,
  AccordionItem,
  Accordion,
  Center,
} from '@chakra-ui/react';
import { map } from 'lodash';
import { customTheme } from 'theme';

import { TriangleDownIcon } from 'components/Icons';
import { permissionStyles } from 'containers/Setup/CloudAccounts/CloudAccountWizard/Components/OnboardAws/styles';
import { collapseExpandIcon } from 'containers/Visibility/Components/InventoryRowDetails/utils';

export const PermissionsRequiredForOnboarding: FC = () => {
  const renderPermission = (label, description) => (
    <Stack spacing={2} pb={2}>
      <Stack textAlign="left">
        <HStack color="primary">
          <Center boxSize={6}>
            <TriangleDownIcon />
          </Center>
          <Box {...permissionStyles.label}>{label}</Box>
        </HStack>
      </Stack>
      <Box pl={8}>{description}</Box>
    </Stack>
  );
  const permissionsMapping = [
    {
      label: 'Owner or User Access Administrator',
      description: 'View under Azure Role Assignments in Entra ID.',
      roleDescription: (
        <Stack spacing={3}>
          {renderPermission(
            'Owner',
            'Grants full access to manage all resources, including the ability to assign roles in Azure RBAC.',
          )}
          {renderPermission(
            'User Access Administrator',
            'Lets you manage user access to Azure resources.',
          )}
        </Stack>
      ),
    },
    {
      label: 'Global Administrator or Privileged Role Administrator',
      description: 'View under Assigned Roles in Entra ID.',
      roleDescription: (
        <Stack spacing={3}>
          {renderPermission(
            'Global Administrator',
            'Can manage all aspects of Microsoft Entra ID and Microsoft services that use Microsoft Entra identities.',
          )}
          {renderPermission(
            'Privileged Role Administrator',
            'Can manage role assignments in Microsoft Entra ID, and all aspects of Privileged Identity Management.',
          )}
        </Stack>
      ),
    },
  ];
  return (
    <Accordion allowMultiple>
      {map(permissionsMapping, o => (
        <AccordionItem border="none" key={o.label + '-permission'}>
          {({ isExpanded }) => (
            <>
              <AccordionButton {...permissionStyles.button} py={3}>
                <Stack textAlign="left">
                  <HStack color="primary">
                    <Center boxSize={6}>
                      {collapseExpandIcon(isExpanded)}
                    </Center>
                    <Box {...permissionStyles.label}>{o?.label}</Box>
                  </HStack>
                  <Box pl={8} color={customTheme.colors.gray['250']}>
                    {o?.description}
                  </Box>
                </Stack>
              </AccordionButton>
              <AccordionPanel pt={0} pb={2} pl={8}>
                <Box>{o?.roleDescription}</Box>
              </AccordionPanel>
            </>
          )}
        </AccordionItem>
      ))}
    </Accordion>
  );
};
